// NO_SONAR
// Copyright (c) 2020 Siemens
import _ from 'lodash';
import eventBus from 'js/eventBus';
import fileSvc from 'js/awFileService';
import DesAwFileDirUploadLabelViewModel from 'viewmodel/DesAwFileDirUploadLabelViewModel';

var fileLabelElement;
var fileNameElement;
var fileNameElementAfterFileUploaded;
var classesForFileLabelElementFocus = [
    'aw-file-uploadFocus',
    'aw-file-uploadFileLabelFocus'
];
var classesForFileNameElementFocus = [
    'aw-file-uploadFocus',
    'aw-file-uploadFileNameFocus'
];

const addStyleToElem = elem => {
    elem.classList.add( 'aw-widgets-dropframe' );
    elem.classList.add( 'aw-theme-dropframe' );
};

const removeStyleFromElem = elem => {
    elem.classList.remove( 'aw-widgets-dropframe' );
    elem.classList.remove( 'aw-theme-dropframe' );
};

const highlightWidget = ( eventData ) => {
    if( !_.isUndefined( eventData ) && !_.isUndefined( eventData.targetElement ) && eventData.targetElement.classList ) {
        let isHighlightFlag = eventData.isHighlightFlag;
        let target = eventData.targetElement;
        if( target.classList.contains( 'aw-widgets-chooseordropfile' ) ) {
            if( isHighlightFlag ) {
                addStyleToElem( target );
            } else {
                removeStyleFromElem( target );
            }
        }
    }
};

export const awFileUploadRenderFunction = ( props ) => {
    const { viewModel, i18n, removeTooltip } = props;
    const { data, dispatch } = viewModel;
    const { fileChangeAction } = props;
    let {
        typeFilter,
        multiple,
        webkitdirectory,
        dndHandler,
        formData
    } = props;
    let attachedFiles;
    let attachedFile = [];
    if( formData instanceof FormData ) {
        for( var value of formData.values() ) {
            attachedFile.push( value );
        }
    }
    if( !multiple && formData instanceof FormData && attachedFile.length > 0 ) {
        attachedFiles = formData;
        data.fileChosen.now = true;
        let fileExt = fileSvc.getFileExtension( attachedFile[0].name );
        if( fileExt !== '' ) {
            fileExt = _.replace( fileExt, '.', '' );
        }
        let validFile = fileSvc.fileMatchTypes( typeFilter, fileExt );
        if( !validFile ) {
            eventBus.publish( 'invalidFileSelected', {} );
            dispatch( { path: 'data.fileChosen', value: { now: false } } );
        }
    } else {
        attachedFiles = data._attachedFiles ? data._attachedFiles : new FormData();
    }
    data._attachedFiles = attachedFiles;

    // ChangeEvent<HTMLInputElement>
    const updateData = ( files, isAppend ) => {
        let validFile = true;
        if( files.length > 0 ) {
            let fileNames = [];
            let fileNameNoExts = [];
            let fileExts = [];
            let fileInputForms = [];
            files.forEach( fileItem => {
                let fileName = fileItem.webkitRelativePath ? fileItem.webkitRelativePath : fileItem.name;
                let fileNameNoExt = fileSvc.getFileNameWithoutExtension( fileName );
                let fileExt = fileSvc.getFileExtension( fileName );
                if( fileExt !== '' ) {
                    fileExt = _.replace( fileExt, '.', '' );
                }
                validFile = fileSvc.fileMatchTypes( typeFilter, fileExt );
                fileNames.push( fileName );
                fileNameNoExts.push( fileNameNoExt );
                fileExts.push( fileExt );
                fileInputForms.push( { selectedFile: fileName, file: fileItem } );
            } );
            if( !multiple ) {
                if( !validFile ) {
                    eventBus.publish( 'invalidFileSelected', {} );
                    dispatch( { path: 'data.fileChosen', value: { now: false } } );
                }
                data.formData = new FormData();
                data.formData.append( 'fmsFile', files[ 0 ] );
                data.fileInputForms = data.formData;
                data.fileName = fileNames[ 0 ];
                data.fileNameNoExt = fileNameNoExts[ 0 ];
                data.fileExt = fileExts[ 0 ];
            } else {
                data.fileName = data.fileName && isAppend ? [ ...data.fileName, ...fileNames ] : fileNames;
                data.fileNameNoExt = data.fileNameNoExt && isAppend ? [ ...data.fileNameNoExt, ...fileNameNoExts ] : fileNameNoExts;
                data.fileExt = data.fileExt && isAppend ? [ ...data.fileExt, ...fileExts ] : fileExts;
                data.fileInputForms = data.fileInputForms && isAppend ? [ ...fileInputForms, ...data.fileInputForms ] : fileInputForms;
            }
            data.validFile = validFile;
            data.fileChosen.now = true;
            dispatch( { path: 'data.fileChosen', value: { now: true } } );

            // call action when file selection changed, inputData : {{ data.formData}}
            if( fileChangeAction ) {
                fileChangeAction( {
                    fileName: data.fileName,
                    fileNameNoExt: data.fileNameNoExt,
                    validFile: data.validFile,
                    fileExt: data.fileExt,
                    formData: data.fileInputForms
                } );
            }
        } else {
            if( fileChangeAction ) {
                fileChangeAction( {
                    fileName: undefined,
                    fileNameNoExt: undefined,
                    validFile: undefined,
                    fileExt: undefined,
                    formData: undefined
                } );
            }
        }
        return validFile;
    };

    let typesSet = null;

    if( typeFilter && '*' !== typeFilter && '.' !== typeFilter ) {
        typesSet = new Set( typeFilter.split( ',' ).map( item => {
            const validFileExt = item.trim();
            return _.replace( validFileExt.toLowerCase(), '.', '' );
        } ) );
    }

    const allFileMatchTypes = ( items ) => {
        if( !typesSet ) {
            return true;
        }
        let allMatched = true;
        const fileItemsArray = Array.from( items );
        fileItemsArray.forEach( fileItem => {
            let fileExt = fileSvc.getFileExtension( fileItem.name );
            if( fileExt !== '' ) {
                fileExt = _.replace( fileExt, '.', '' );
            }
            if( !typesSet.has( fileExt.toLowerCase() ) ) {
                allMatched = false;
            }
        } );
        return allMatched;
    };

    // ChangeEvent<HTMLInputElement>
    const handleFileChange = ( e ) => {
        const files = e.target.files;
        let filesArr = Array.from( files );
        updateAttachedFiles( filesArr );
        e.target.value = '';
    };

    const isFileUploadWidgetFocused = () => {
        let fileInputElement = document.getElementsByClassName( 'aw-file-upload-fileInput' );
        if( fileInputElement && fileInputElement.length > 0 ) {
            return document.activeElement === fileInputElement[ 0 ];
        }
        return false;
    };

    const handleFocus = () => {
        fileLabelElement = document.getElementsByClassName( 'aw-file-upload-fileLabel' );
        if( fileLabelElement && fileLabelElement.length > 0 ) {
            fileLabelElement[ 0 ].classList.add( ...classesForFileLabelElementFocus );
        }

        fileNameElement = document.getElementsByClassName( 'aw-file-upload-fileName' );
        if( fileNameElement && fileNameElement.length > 0 ) {
            fileNameElement[ 0 ].classList.add( ...classesForFileNameElementFocus );
        }
    };

    const handleBlur = () => {
        if( fileLabelElement && fileLabelElement.length > 0 ) {
            fileLabelElement[ 0 ].classList.remove( ...classesForFileLabelElementFocus );
        }
        if( fileNameElement && fileNameElement.length > 0 ) {
            fileNameElement[ 0 ].classList.remove( ...classesForFileNameElementFocus );
        }

        fileNameElementAfterFileUploaded = document.getElementsByClassName( 'file-upload-selected-file' );
        if( fileNameElementAfterFileUploaded && fileNameElementAfterFileUploaded.length > 0 ) {
            fileNameElementAfterFileUploaded[ 0 ].classList.remove( ...classesForFileNameElementFocus );
        }
    };

    const getClassesAfterFileUpload = () => {
        if( isFileUploadWidgetFocused() ) {
            return 'aw-file-upload-fileName '
                .concat( 'file-upload-selected-file ' )
                .concat( 'aw-file-uploadFocus ' )
                .concat( 'aw-file-uploadFileNameFocus' );
        }
        return 'aw-file-upload-fileName '
            .concat( 'file-upload-selected-file' );
    };

    const refreshFileListInfo = ( isChosen ) => {
        dispatch( { path: 'data.fileChosen', value: { now: isChosen } } );
    };

    // Deletes file from attachedFiles list
    const deleteFile = ( name ) => {
        let fileNames = data.fileName;
        if( _.isArray( fileNames ) ) {
            let indxToRemove = fileNames.indexOf( name );
            data.fileName.splice( indxToRemove, 1 );
            data.fileNameNoExt.splice( indxToRemove, 1 );
            data.fileInputForms.splice( indxToRemove, 1 );
            data.fileExt.splice( indxToRemove, 1 );
        }
        attachedFiles.delete( name );
    };

    /**
     * @param { File[] } files - files
     * @return {File[] } resultFiles
     */
    const filterTypes = function( files ) {
        let allMatchedType = true;

        if( !typesSet ) {
            return files;
        }
        const resultFiles = files.filter( file => {
            const fileTypes = file.name.split( '.' );
            // in case of 1.x.dat
            const fileType = fileTypes[ fileTypes.length - 1 ];
            if( !multiple || typesSet.has( fileType ) ) {
                return true;
            }
            allMatchedType = false;
            return false;
        } );
        if( !allMatchedType ) {
            eventBus.publish( 'invalidFileSelected', {} );
        }
        return resultFiles;
    };

    /**
     *
     * @param { File[] } filesArray - array of files to be uploaded
     * @param { Boolean } isAppend - isAppend
     */
    const updateAttachedFiles = ( filesArray, isAppend = true ) => {
        updateData( filesArray, isAppend );
        const typeFilterFiles = filterTypes( filesArray );
        if( !multiple && typeFilterFiles.length > 0 ) {
            //If single mode and typeFilterFiles are valid , delete existing file before updating
            for( var file of attachedFiles.values() ) {
                deleteFile( file.name );
            }
        }
        typeFilterFiles.forEach( ( file ) => {
            attachedFiles.set( file.name, file );
        } );
        refreshFileListInfo( true );
    };

    const handleImplicitFilesAttachment = e => {
        if( fileSvc.dataTransferContainsFiles( e ) && allFileMatchTypes( e.dataTransfer.files ) ) {
            const filesArray = Array.from( e.dataTransfer.files );
            updateAttachedFiles( filesArray );
        }
    };

    const callbackAPIs = {
        highlightTarget: highlightWidget,
        updateFileData: handleImplicitFilesAttachment,
        getTargetElementAndVmo: ( event ) => {
            let targetVMO = null;
            let target = event.currentTarget;
            return {
                targetElement: target,
                targetVMO: targetVMO
            };
        }
    };

    //DragEvent<HTMLElement>
    const handleDrop = ( e ) => {
        let targetEle = e.currentTarget;
        // logic of applying DnD style on element and DnD cursor change is assumed to be implicit functionalities
        // hence NOT leaving it to contributed handlers to implement it
        removeStyleFromElem( targetEle );
        if( e.dataTransfer ) {
            e.dataTransfer.dropEffect = 'none';
            e.preventDefault();
        }
        handleDrag( false );

        if( dndHandler && dndHandler[ e.type ] ) {
            let fun = dndHandler[ e.type ];
            fun( e, { targetElement: targetEle, targetVMO: null }, callbackAPIs );
        } else {
            handleImplicitFilesAttachment( e );
        }
    };
    const handleClickDeselect = ( e, name ) => {
        e.preventDefault();
        deleteFile( name );
        updateAttachedFiles( getAttachedFiles(), false );
    };

    const getAttachedFiles = () => {
        let attachedFileArray = [];
        for( var value of attachedFiles.values() ) {
            attachedFileArray.push( value );
        }
        return attachedFileArray;
    };

    // set Dragger highlight when over: boolean
    const handleDrag = ( over ) => {
        dispatch( { path: 'data.isDragOn', value: over } );
    };

    const fileDragOver = ( e ) => {
        let targetEle = e.currentTarget;
        // logic of applying DnD style on element and DnD cursor change is assumed to be implicit functionalities
        // hence NOT leaving it to contributed handlers to implement it
        addStyleToElem( targetEle );
        e.preventDefault();
        e.stopPropagation();

        if( dndHandler && dndHandler[ e.type ] ) {
            let fun = dndHandler[ e.type ];
            fun( e, { targetElement: targetEle, targetVMO: null }, callbackAPIs );
        }
    };
    // clear the drag style after drop or drop leave
    /**
     * @param {DragEvent<HtmlElement>} e : the drag event
     */
    const fileDragLeave = e => {
        let targetEle = e.currentTarget;
        // logic of applying DnD style on element and DnD cursor change is assumed to be implicit functionalities
        // hence NOT leaving it to contributed handlers to implement it
        removeStyleFromElem( targetEle );
        if( e.dataTransfer ) {
            e.dataTransfer.dropEffect = 'none';
            e.preventDefault();
        }
        handleDrag( false );
        if( dndHandler && dndHandler[ e.type ] ) {
            let fun = dndHandler[ e.type ];
            fun( e, { targetElement: targetEle, targetVMO: null }, callbackAPIs );
        }
    };

    let filesToDisp = getAttachedFiles();
    return (
        <div className = 'aw-file-upload-container aw-file-upload-initial aw-widgets-chooseordropfile' onDragOver = { e => fileDragOver( e )}
            onDragLeave={e => { fileDragLeave( e ); } } onDrop={handleDrop}>
            <div className = 'sw-row'>
                { !webkitdirectory && <div className = 'aw-file-upload-fileLabel'>  { i18n.ChooseFile } </div> }
                { webkitdirectory && <div className = 'aw-file-upload-fileLabel'>  { i18n.ChooseDir } </div> }
                { filesToDisp && filesToDisp.length === 0 && !multiple && <div className='aw-file-upload-fileName'> { i18n.singleUpload } </div> }
                {  multiple && <div className='aw-file-upload-fileName'> { i18n.multipleUpload } </div> }
                { filesToDisp && filesToDisp.length > 0 && data.fileChosen.now && !multiple && <div onDrop={handleDrop} className={ getClassesAfterFileUpload() }>
                    <DesAwFileDirUploadLabelViewModel removeTooltip={removeTooltip} key={filesToDisp[0].name} item={filesToDisp[0]} removeFileHandler={handleClickDeselect}/>
                </div> }
                { webkitdirectory &&
                    <input data-locator='aw-fileUpload' multiple =  { multiple } webkitdirectory='' className = 'aw-file-upload-fileInput' type='file'  accept = { typeFilter }
                        onChange={ handleFileChange } title={filesToDisp && filesToDisp[0] && filesToDisp[0].name} onFocus={ handleFocus } onBlur={ handleBlur }
                    />
                }
                { !webkitdirectory &&
                    <input data-locator='aw-fileUpload' multiple =  { multiple } className = 'aw-file-upload-fileInput' type='file'  accept = { typeFilter }
                        onChange={ handleFileChange } title={filesToDisp && filesToDisp[0] && filesToDisp[0].name} onFocus={ handleFocus } onBlur={ handleBlur }
                    />
                }
            </div>
            {
                multiple && filesToDisp && filesToDisp.length > 0 &&
                    <ul className = 'aw-upload-list-items'>
                        {
                            filesToDisp.map( item=>{
                                return (
                                    <li className = 'sw-flex-row' key={item.name}>
                                        <DesAwFileDirUploadLabelViewModel removeTooltip={removeTooltip}  item={item} removeFileHandler={handleClickDeselect}></DesAwFileDirUploadLabelViewModel>
                                    </li>
                                );
                            } )
                        }
                    </ul>
            }
        </div>
    );
};
// NO_SONAR
